import { Dialog } from "@headlessui/react";
import {
  EllipsisVerticalIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  UserPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import CustomerList from "./CustomerList";
import { DataContext } from "../../helper/HelperOne";
import HeaderWithButton from "../Utility/HeaderWithButton";
import { Country, State, City } from "country-state-city";
import TopFilters from "../Utility/TopFilters";
import TopStats from "../Utility/TopStats";
import { CubeIcon } from "@heroicons/react/20/solid";
import { UsersIcon } from "lucide-react";
import LabelTopView from "../Utility/LabelTopView";
import UpdateConfirmation from "../Utility/UpdateConfirmation";

function CustomerCreate() {
  const user = JSON.parse(localStorage.getItem("user"));
  const customerPermission = user?.customer_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );
 

  const userForEdit = JSON.parse(localStorage.getItem("user"));
  const customerPermissionForEdit =
    userForEdit?.customer_role_based_access?.some(
      (access) => access.label_id == 3 && access.label_value != 0
    );
  
    const [filterParams, setFilterParams] = useState(""); 

  const { searchData } = useContext(DataContext);

  const [openDialogBoxForCustomers, setOpenDialogBoxForCustomers] =
    useState(false);
  const [saveBtn, setSaveBtn] = useState("save");
  const [customersDataList, setCustomersDataList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [paginationCustomerData, setPaginationCustomerData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [editIdCryptForCustomers, setEditIdCryptForCustomers] = useState(null);
  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editCustomerIdCrypty, setEditCustomerIdCrypty] = useState("");

  const [customersDatas, setCustomersDatas] = useState({
    salutation: "",
    first_name: "",
    last_name: "",
    company_name: "",
    customer_display_name: "",
    customer_type: "",
    designation: "",
    department: "",
    customer_email: "",
    customer_phone: "",
    website: "",
    gst_number: "",
    place_of_supply: "",
    attention: "",
    address_line_1: "",
    address_line_2: "",
    city: "",
    state: "",
    pin_code: "",
    phone: "",
    remarks: "",
    country: "",
  });

  const [contact_details, setContact_details] = useState([
    {
      contact_person: "",
      contact_number: "",
      contact_email: "",
      contact_designation: "",
    },
  ]);

  const mergedCustomersAndContacts = { ...customersDatas, contact_details };

  const [filterData, setFilterData] = useState({
    first_name: "",
    company_name: "",
    customer_email: "",
    customer_phone: "",
  });


  const fetchCustomersData = async (page = 1, queryParams = "") => {
    const token = localStorage.getItem("token");

    try {
        // Merge stored filters with new filters if any
        const finalQueryParams = filterParams
            ? `${filterParams}${queryParams ? `&${queryParams}` : ""}`
            : queryParams;

        // Construct API URL with pagination, search, and filters
        const apiUrl = `public/api/admin/customer/pagination?page=${page}${
            finalQueryParams ? `&${finalQueryParams}` : ""
        }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;

 

        const response = await axios.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

   

        // Update state with the fetched data
        setCustomersDataList(response.data.customers.data);
        setPaginationCustomerData(response.data.customers);
    } catch (error) {
        console.error("Error fetching customer data:", error);
    }
};


useEffect(() => {
  fetchCustomersData(currentPage, filterParams);
}, [searchData, currentPage, filterParams]); 


  const fields = [
    {
      name: "first_name",
      type: "text",
      placeholder: "Name",
      componentType: "select",
      options: customersDataList.map((customer) => ({
        value: customer.first_name,
        label: customer.first_name,
      })),
    },
    {
      name: "company_name",
      type: "text",
      placeholder: " Company",
      componentType: "select",
      options: Array.from(
        new Set(customersDataList.map((customer) => customer.company_name))
      ).map((company) => ({
        value: company,
        label: company,
      })),
    },
    {
      name: "customer_email",
      type: "email",
      placeholder: " Email",
      componentType: "select",
      options: customersDataList.map((customer) => ({
        value: customer.customer_email,
        label: customer.customer_email,
      })),
    },
    {
      name: "customer_phone",
      type: "tel",
      placeholder: " Phone",
      componentType: "select",
      options: customersDataList.map((customer) => ({
        value: customer.customer_phone,
        label: customer.customer_phone,
      })),
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  const handleFilter = () => {
    const queryParams = new URLSearchParams();

    if (filterData.first_name) {
        queryParams.append("first_name", filterData.first_name);
    }
    if (filterData.company_name) {
        queryParams.append("company_name", filterData.company_name);
    }
    if (filterData.customer_email) {
        queryParams.append("customer_email", filterData.customer_email);
    }
    if (filterData.customer_phone) {
        queryParams.append("customer_phone", filterData.customer_phone);
    }

    const queryString = queryParams.toString();

 
    setFilterParams(queryString);


    fetchCustomersData(1, queryString);
};


  const handleReset = async () => {

    setFilterData({ name: "", company_name: "", email: "", phone_number: "" });
    await fetchCustomersData();
    setFilterParams("")
  };

  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const filteredStates = customersDatas.country
    ? State.getStatesOfCountry(customersDatas.country).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  const filteredCities =
    customersDatas.state && customersDatas.country
      ? City.getCitiesOfState(customersDatas.country, customersDatas.state).map(
          (city) => ({
            label: city.name,
            value: city.name,
          })
        )
      : [];

  const handleChangeForCustomers = (e) => {
    const { name, value } = e.target;

    setCustomersDatas((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleContactPersonChange = (e, index) => {
    const { name, value } = e.target;
    const newData = [...contact_details];
    newData[index][name] = value;
    setContact_details(newData);
  };

  const AddContactPerson = (e) => {
    e.preventDefault();
    setContact_details([
      ...contact_details,
      {
        contact_person: "",
        contact_email: "",
        contact_number: "",
        contact_designation: "",
      },
    ]);
  };

  const handleRemoveContactPerson = (index) => {
    const newData = [...contact_details];
    newData.splice(index, 1);
    setContact_details(newData);
  };

  const handleAddCustomer = () => {
    setOpenDialogBoxForCustomers(true);
    setSaveBtn("save");
    setCustomersDatas({
      salutation: "",
      first_name: "",
      last_name: "",
      company_name: "",
      customer_display_name: "",
      customer_type: "",
      designation: "",
      department: "",
      customer_email: "",
      customer_phone: "",
      website: "",
      gst_number: "",
      place_of_supply: "",
      attention: "",
      address_line_1: "",
      address_line_2: "",
      city: "",
      state: "",
      pin_code: "",
      phone: "",
      remarks: "",
      country: "",
    });
    setContact_details([
      {
        contact_person: "",
        contact_number: "",
        contact_email: "",
        contact_designation: "",
      },
    ]);
  };

  const handleSubmitForCustomers = async (e) => {
    e.preventDefault();

    try {
      const requestData = {
        ...customersDatas,
        contact_details: contact_details,
      };

   

      const response = await axios.post(
        "public/api/admin/customer/store",
        requestData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("Customer added successfully");
      await fetchCustomersData();
      setOpenDialogBoxForCustomers(false);
    } catch (error) {
   
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEditForCustomers = async (id_crypt) => {
    setIsEditing(false);
    setOpenDialogBoxForCustomers(true);
    toast.success("Now You Can Edit This Customer");
    setEditIdCryptForCustomers(id_crypt);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/customer/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

  

      setCustomersDatas((prev) => ({
        ...prev,
        name: response.data.customer.name,
        salutation: response.data.customer.salutation,
        first_name: response.data.customer.first_name,
        last_name: response.data.customer.last_name,
        company_name: response.data.customer.company_name,
        customer_display_name: response.data.customer.customer_display_name,
        customer_type: response.data.customer.customer_type,
        designation: response.data.customer.designation,
        department: response.data.customer.department,
        customer_email: response.data.customer.customer_email,
        customer_phone: response.data.customer.customer_phone,
        website: response.data.customer.website,
        gst_number: response.data.customerbillingdetails.gst_number,
        place_of_supply: response.data.customerbillingdetails.place_of_supply,
        contact_person: response.data.customer.contact_person,
        contact_number: response.data.customer.contact_number,
        contact_email: response.data.customer.contact_email,
        contact_designation: response.data.customer.contact_designation,
        attention: response.data.customerbillingdetails.attention,
        address_line_1: response.data.customerbillingdetails.address_line_1,
        address_line_2: response.data.customerbillingdetails.address_line_2,
        city: response.data.customerbillingdetails.city,
        state: response.data.customerbillingdetails.state,
        pin_code: response.data.customerbillingdetails.pin_code,
        phone: response.data.customerbillingdetails.phone,
        remarks: response.data.customerbillingdetails.remarks,
        country: response.data.customerbillingdetails.country,
      }));

      const customerOtherDetails = response.data.customerotherdetails || [];

    

      if (customerOtherDetails.length > 0) {
        setContact_details(
          customerOtherDetails.map((item) => ({
            contact_person: item.contact_person || "",
            contact_number: item.contact_number || "",
            contact_email: item.contact_email || "",
            contact_designation: item.contact_designation || "",
          }))
        );
      }
    } catch (err) {
      toast.error(err.response.data.message);
    }
  };

  const handleUpdateForCustomers = async (e) => {
    e.preventDefault();
    try {
      const requestData = {
        ...customersDatas,
        contact_details: contact_details,
      };

 

      const response = await axios.put(
        `public/api/admin/customer/update/${editIdCryptForCustomers}`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      toast.success("Customer updated successfully");
      await fetchCustomersData();
      setOpenDialogBoxForCustomers(false);
    } catch (error) {

      toast.error(error.response.data.message);
    }
  };

  const statsFieldNames = [
    {
      title: "Total Customers",
      value: customersDataList.length,
      color: "blue",
      bg: "bg-blue-50",

      link: "/crm/customers",
    },
    // {
    //   title: "Active Customers",
    //   value: customersDataList.filter((item) => item.status === "Active")
    //     .length,
    //   color: "green",
    //   bg: "bg-green-50",

    //   link: "/crm/customers/active",
    // },
    // {
    //   title: "Inactive Customers",
    //   value: customersDataList.filter((item) => item.status === "Inactive")
    //     .length,
    //   color: "red",
    //   bg: "bg-red-50",
    //   link: "/crm/customers/inactive",
    // },
    {
      title: "This Month Customers",
      value: getMonthlyCustomers(customersDataList),
      color: "indigo",
      bg: "bg-purple-50",
      link: "/crm/customers/monthly",
    },
    {
      title: "Converted From Leads",
      value: customersDataList.filter((item) => item.status === "Lead").length,
      color: "yellow",
      bg: "bg-yellow-50",
      link: "/crm/customers/converted",
    },
  ];

  function getMonthlyCustomers(data) {
    const now = new Date();
    return data.filter((item) => {
      const itemDate = new Date(item.created_at.split("T")[0]);
      return (
        itemDate.getMonth() === now.getMonth() &&
        itemDate.getFullYear() === now.getFullYear()
      );
    }).length;
  }

  function getConvertedCustomers(data) {
    return data.filter((item) => item.converted).length;
  }

  const handleDialogClose = async () => {
    setLoading(true);
    try {
      await fetchCustomersData();
      setOpenDialogBoxForCustomers(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>
          <LabelTopView label="Customer Overview" icon={<UsersIcon />} />
          <TopStats statsFieldNames={statsFieldNames} />

          <HeaderWithButton
            title="Customer"
            description="customers"
            buttonText="Customer"
            onButtonClick={handleAddCustomer}
            // showButton={customerPermission}
          />

          <TopFilters
            fields={fields}
            filterData={filterData}
            handleChange={handleChange}
            handleFilter={handleFilter}
            handleReset={handleReset}
          />

          <CustomerList
            setCustomersDataList={setCustomersDataList}
            customersDataList={customersDataList}
            paginationCustomerData={paginationCustomerData}
            // setEditId={setEditId}
            setOpenDialogBoxForCustomers={setOpenDialogBoxForCustomers}
            setCustomersDatas={setCustomersDatas}
            customersDatas={customersDatas}
            editId={editId}
            setEditId={setEditId}
            setSaveBtn={setSaveBtn}
            fetchCustomersData={fetchCustomersData}
            setContact_details={setContact_details}
            setCurrentPage={setCurrentPage}
            setEditIdCryptForCustomers={setEditIdCryptForCustomers}
            setIsEditing={setIsEditing}
            setEditCustomerIdCrypty={setEditCustomerIdCrypty}
            filterParams={filterParams}
          />

          {openDialogBoxForCustomers && (
            <Dialog
              open={openDialogBoxForCustomers}
              onClose={() => {}}
              className="relative z-10"
              autoFocus={false}
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-95 transition-opacity" />

              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className=" flex min-h-full items-end justify-center p-4 text-center sm:items-center  md:min-h-screen sm:p-0">
                  <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                    <div
                      className="flex justify-between p-4 text-white sticky top-0 z-50"
                      style={{ backgroundColor: "#6366f1" }}
                    >
                      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium uppercase ">
                        Customer Info
                      </h1>

                      <div className="flex gap-2">
                        
                        {customerPermissionForEdit && isEditing && (
                          <div className="relative">
                            <button
                              type="button"
                              className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                              aria-expanded={isOpenEdit}
                            >
                              <PencilSquareIcon
                                // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                                onClick={() => {
                                  handleEditForCustomers(editCustomerIdCrypty);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                                className="h-6 w-6 cursor-pointer text-white"
                              />
                            </button>

                            {/* {isOpenEdit && (
                          <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                            <div className="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                              <button
                                type="button"
                                className="block w-full text-left p-2 hover:text-indigo-600"
                                onClick={() => {
                                  handleEditForCustomers(editCustomerIdCrypty);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                              >
                                Edit
                              </button>
                            </div>
                          </div>
                        )} */}
                          </div>
                        )}
                        <XMarkIcon
                          onClick={handleDialogClose}
                          className="h-6 w-6 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="md:grid md:gap-6 p-4">
                      <div className="md:mt-0 md:col-span-2">
                        <form className="grid grid-cols-1  md:grid-cols-1 gap-y-6 ">
                          <div className=" overflow-hidden">
                            <div className="p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    SALUTATION
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="salutation"
                                      type="text"
                                      value={customersDatas.salutation}
                                      onChange={handleChangeForCustomers}
                                      placeholder="SALUTATION"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {/* {requiredFields.salutation && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields.salutation}
                                </p>
                              )} */}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center justify-between">
                                    <label
                                      htmlFor="customer_id"
                                      className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                    >
                                      FIRST NAME
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      name="first_name"
                                      type="text"
                                      value={customersDatas.first_name}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="FIRST NAME"
                                    />

                                    {/* {requiredFields.first_name && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.customer_id}
                                  </p>
                                )} */}
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="start_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    LAST NAME
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="last_name"
                                      type="text"
                                      value={customersDatas.last_name}
                                      onChange={handleChangeForCustomers}
                                      autoComplete="start_date"
                                      placeholder="LAST NAME"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-6 gap-6 mt-4 sm:mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    COMPANY NAME
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="company_name"
                                      type="text"
                                      value={customersDatas.company_name}
                                      onChange={handleChangeForCustomers}
                                      placeholder="COMPANY NAME"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {/* {requiredFields.company_name && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields.company_name}
                                </p>
                              )} */}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center justify-between">
                                    <label
                                      htmlFor="customer_id"
                                      className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                    >
                                      CUSTOMER DISPLAY NAME
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      name="customer_display_name"
                                      type="text"
                                      value={
                                        customersDatas.customer_display_name
                                      }
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="CUSTOMER DISPLAY NAME"
                                    />

                                    {/* {requiredFields.customer_display_name && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.customer_display_name}
                                  </p>
                                )} */}
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="start_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    CUSTOMER TYPE
                                  </label>
                                  <div className="mt-2">
                                    {/* <input
                                  name="customer_type"
                                  type="text"
                                  value={customersDatas.customer_type}
                                  onChange={handleChangeForCustomers}
                                  autoComplete="start_date"
                                  placeholder="TYPE"
                                  className={`block w-full ${isEditing && 'bg-gray-100'} rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                /> */}
                                    <select
                                      name="customer_type"
                                      value={customersDatas.customer_type}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    >
                                      <option>Select Customer Type</option>
                                      <option value="0">Individual</option>
                                      <option value="1">Business</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 mt-5">
                                <div className="col-span-full sm:col-span-3 lg:col-span-2">
                                  <label className="block text-sm font-medium text-gray-700">
                                    DESIGNATION
                                  </label>
                                  <input
                                    name="designation"
                                    type="text"
                                    value={customersDatas.designation}
                                    onChange={handleChangeForCustomers}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border-0 mt-2 sm:mt-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="DESIGNATION"
                                  />
                                </div>

                                <div className="col-span-full sm:col-span-3 lg:col-span-2">
                                  <label className="block text-sm font-medium text-gray-700">
                                    DEPARTMENT
                                  </label>
                                  <input
                                    name="department"
                                    type="text"
                                    value={customersDatas.department}
                                    onChange={handleChangeForCustomers}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border-0 mt-2 sm:mt-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="DEPARTMENT"
                                  />
                                </div>

                                <div className="col-span-full sm:col-span-3 lg:col-span-2">
                                  <label className="block text-sm font-medium text-gray-700">
                                    CUSTOMER PHONE
                                  </label>
                                  <input
                                    name="customer_phone"
                                    type="text"
                                    value={customersDatas.customer_phone}
                                    onChange={handleChangeForCustomers}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border-0 mt-2 sm:mt-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="MOBILE"
                                  />
                                </div>
                              </div>

                              <div className="grid grid-cols-6 gap-6 mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    CUSTOMER EMAIL
                                  </label>

                                  <div className="mt-2">
                                    <input
                                      name="customer_email"
                                      value={customersDatas.customer_email}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="EMAIL"
                                    />
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    WEBSITE
                                  </label>
                                  <input
                                    name="website"
                                    value={customersDatas.website}
                                    onChange={handleChangeForCustomers}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border-0 mt-2 sm:mt-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="WEBSITE"
                                  />
                                </div>
                              </div>

                              <h2 className="font-medium mb-2 mt-5 uppercase">
                                TAX INFORMATION :
                              </h2>

                              <div className="grid grid-cols-6 gap-6 mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    GSTIN/UIN
                                  </label>

                                  <div className="mt-2">
                                    <input
                                      name="gst_number"
                                      value={customersDatas.gst_number}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="GSTIN/UIN"
                                    />
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="end_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    PLACE OF SUPPLY
                                  </label>
                                  <input
                                    name="place_of_supply"
                                    value={customersDatas.place_of_supply}
                                    onChange={handleChangeForCustomers}
                                    className={`block w-full ${
                                      isEditing && "bg-gray-100"
                                    } rounded-md border-0 mt-2 sm:mt-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                    disabled={isEditing}
                                    placeholder="PLACE OF SUPPLY"
                                  />
                                </div>
                              </div>

                              <h2 className="font-medium mb-2 mt-5 uppercase">
                                BILLING ADDRESS :
                              </h2>

                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    ATTENTION
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="attention"
                                      type="text"
                                      value={customersDatas.attention}
                                      onChange={handleChangeForCustomers}
                                      placeholder="ATTENTION"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {/* {requiredFields.attention && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields.attention}
                                </p>
                              )} */}
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="start_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    ADDRESS 1
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="address_line_1"
                                      type="text"
                                      value={customersDatas.address_line_1}
                                      onChange={handleChangeForCustomers}
                                      autoComplete="start_date"
                                      placeholder="ADDRESS 1"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    ADDRESS 2
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="address_line_2"
                                      type="text"
                                      value={customersDatas.address_line_2}
                                      onChange={handleChangeForCustomers}
                                      placeholder="ADDRESS 2"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {/* {requiredFields.project_name && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields.project_name}
                                </p>
                              )} */}
                                </div>
                              </div>

                              <div className="grid grid-cols-6 gap-6 mt-4 sm:mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center justify-between">
                                    <label
                                      htmlFor="customer_id"
                                      className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                    >
                                      COUNTRY / REGION
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <select
                                      name="country"
                                      value={customersDatas.country || ""}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    >
                                      <option value="" disabled>
                                        Select Country / Region
                                      </option>
                                      {countryOptions.map((country) => (
                                        <option
                                          key={country.value}
                                          value={country.value}
                                        >
                                          {country.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center justify-between">
                                    <label
                                      htmlFor="customer_id"
                                      className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                    >
                                      CITY
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    {/* <input
                                  name="city"
                                  type="text"
                                  value={customersDatas.city}
                                  onChange={handleChangeForCustomers}
                                  className={`block w-full ${isEditing && 'bg-gray-100'} rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="CITY"
                                /> */}

                                    <select
                                      name="city"
                                      value={customersDatas.city || ""}
                                      onChange={handleChangeForCustomers}
                                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                                      disabled={
                                        !customersDatas.state || isEditing
                                      } // Disable if no state is selected
                                    >
                                      <option value="" disabled>
                                        Select City
                                      </option>
                                      {filteredCities.map((city) => (
                                        <option
                                          key={city.value}
                                          value={city.value}
                                        >
                                          {city.label}
                                        </option>
                                      ))}
                                    </select>

                                    {/* {requiredFields.customer_id && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.customer_id}
                                  </p>
                                )} */}
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="start_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    STATE / PROVINCE
                                  </label>
                                  <div className="mt-2">
                                    <select
                                      name="state"
                                      value={customersDatas.state || ""}
                                      onChange={handleChangeForCustomers}
                                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                                      disabled={!customersDatas.country} // Disable if no country is selected
                                    >
                                      <option value="" disabled>
                                        Select State / Province
                                      </option>
                                      {filteredStates.map((state) => (
                                        <option
                                          key={state.value}
                                          value={state.value}
                                        >
                                          {state.label}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  {/* <div className="mt-2">
                                <input
                                  name="state"
                                  type="text"
                                  value={customersDatas.state}
                                  onChange={handleChangeForCustomers}
                                  
                                  placeholder="STATE"
                                  className={`block w-full ${isEditing && 'bg-gray-100'} rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                 
                                />
                              </div> */}
                                </div>
                              </div>

                              <div className="grid grid-cols-6 gap-6 mt-4 sm:mt-5">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label className="block text-sm font-medium leading-6 text-gray-900">
                                    ZIPCODE
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="pin_code"
                                      type="text"
                                      value={customersDatas.pin_code}
                                      onChange={handleChangeForCustomers}
                                      placeholder="ZIPCODE"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                  {/* {requiredFields.pincode && (
                                <p className="mt-1 text-sm text-red-600">
                                  {requiredFields.pincode}
                                </p>
                              )} */}
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <div className="flex items-center justify-between">
                                    <label
                                      htmlFor="customer_id"
                                      className="block text-sm font-medium leading-6 text-gray-900 flex items-center"
                                    >
                                      MOBILE
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      name="phone"
                                      type="text"
                                      value={customersDatas.phone}
                                      onChange={handleChangeForCustomers}
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                      placeholder="MOBILE"
                                    />

                                    {/* {requiredFields.phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields.phone}
                                  </p>
                                )} */}
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="start_date"
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    REMARKS
                                  </label>
                                  <div className="mt-2">
                                    <input
                                      name="remarks"
                                      type="text"
                                      value={customersDatas.remarks}
                                      onChange={handleChangeForCustomers}
                                      autoComplete="start_date"
                                      placeholder="REMARKS"
                                      className={`block w-full ${
                                        isEditing && "bg-gray-100"
                                      } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                      disabled={isEditing}
                                    />
                                  </div>
                                </div>
                              </div>

                              <h2 className="font-medium mb-2 mt-5 uppercase ">
                                Contact Person Details :
                              </h2>

                              <div className="overflow-x-auto">
                                {/* Header Row */}
                                <div className="min-w-[800px] grid grid-cols-10 gap-6 font-medium text-gray-900 bg-gray-100 p-2 rounded-md">
                                  <div className="col-span-2">NAME</div>
                                  <div className="col-span-2">PHONE</div>
                                  <div className="col-span-2">EMAIL</div>
                                  <div className="col-span-3">DESIGNATION</div>
                                  <div className="col-span-1 text-right">
                                    ACTION
                                  </div>
                                </div>

                                {/* Data Rows */}
                                {contact_details.map((item, index) => (
                                  <div
                                    key={index}
                                    className="min-w-[800px] grid grid-cols-10 gap-6 border-b p-2 items-center"
                                  >
                                    {/* Name */}
                                    <div className="col-span-2">
                                      <input
                                        name="contact_person"
                                        type="text"
                                        value={item.contact_person}
                                        onChange={(e) =>
                                          handleContactPersonChange(e, index)
                                        }
                                        placeholder="PERSON NAME"
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                        disabled={isEditing}
                                      />
                                    </div>

                                    {/* Email */}
                                    <div className="col-span-2">
                                      <input
                                        name="contact_number"
                                        type="text"
                                        value={item.contact_number}
                                        onChange={(e) =>
                                          handleContactPersonChange(e, index)
                                        }
                                        placeholder="PHONE NUMBER"
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                        disabled={isEditing}
                                      />
                                    </div>

                                    {/* Phone */}
                                    <div className="col-span-2">
                                      <input
                                        name="contact_email"
                                        type="text"
                                        value={item.contact_email}
                                        onChange={(e) =>
                                          handleContactPersonChange(e, index)
                                        }
                                        placeholder="EMAIL"
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                        disabled={isEditing}
                                      />
                                    </div>

                                    {/* Position */}
                                    <div className="col-span-3">
                                      <input
                                        name="contact_designation"
                                        type="text"
                                        value={item.contact_designation}
                                        onChange={(e) =>
                                          handleContactPersonChange(e, index)
                                        }
                                        placeholder="DESIGNATION"
                                        className={`block w-full ${
                                          isEditing && "bg-gray-100"
                                        } rounded-md border border-gray-300 py-1.5 text-gray-900 shadow-sm focus:ring-2 focus:ring-indigo-600 sm:text-sm`}
                                        disabled={isEditing}
                                      />
                                    </div>

                                    {/* Remove Button - Same Line */}
                                    <div className="col-span-1 flex items-center justify-end">
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleRemoveContactPerson(index)
                                        }
                                        className="bg-red-500 text-white p-2 rounded-full"
                                      >
                                        <XMarkIcon className="w-2 h-2 sm:w-3 sm:h-3" />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <button
                                onClick={(e) => AddContactPerson(e)}
                                className="bg-white mt-4  "
                              >
                                <PlusCircleIcon className="w-6 h-6 text-blue-500 bg-white" />
                              </button>

                              {/* Save Button */}
                            </div>
                            <div className="flex justify-end">
                              {saveBtn === "save" ? (
                                <div className="bg-white mt-6">
                                  <button
                                    onClick={handleSubmitForCustomers}
                                    className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                  >
                                    Save
                                  </button>
                                </div>
                              ) : (
                                <div className="bg-white mt-6">
                                  {/* <button
                                onClick={handleUpdateForCustomers}
                                className="flex justify-end py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Update
                              </button> */}
                                  <UpdateConfirmation
                                    id_crypt={editCustomerIdCrypty}
                                    apiType="customer"
                                    fetchClientData={fetchCustomersData}
                                    inputs={mergedCustomersAndContacts}
                                    dialogClose={setOpenDialogBoxForCustomers}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </Dialog.Panel>
                </div>
              </div>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}

export default CustomerCreate;
